import React from 'react';

const LoadingScreen = () => {
    return (
        <div className="loading-screen">
            <div className="spinner"></div>
            <p>Carregando...</p>
        </div>
    );
};

export default LoadingScreen;